import React from "react";
import { ProfileTemplate } from "../../Templates/ProfileTemplate";

export const Profile = () => {
  return <ProfileTemplate />;
};
